<template>
    <div class="my-3" v-if="buttons && buttons.length">
        <div class="boost-section">
            <p>
                Reichtweite erhöhen - Unsere <b>Performance Booster</b> für Ihre Anzeige.<br>
                Klicken Sie auf einen <b>Booster</b> um Impressionen und Klicks zu erhöhen:
            </p>


            <div class="">
                <div
                    v-for="btn in buttons"
                    class=" cursor-pointer badge-hover badge badge-large badge-auto my-1 mx-1"
                    @click.prevent="onClick(btn)"
                >
                    <div class="my-1 mx-1">
                        {{ btn.name }}
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <ProductPayment />
        <Upselling @reloadData="reloadData" />
    </div>
</template>
<script>
import axios from 'axios'
import ProductPayment from '../../ProductPayment.vue'
import emitter from '../../../plugins/mitt'
import Preview from './Preview.vue'
import Upselling from '../../Upselling.vue'
export default {
    name: 'BoostEntry',
    components: {
        ProductPayment,
        Preview,
        Upselling
    },
    props: {
        type: {
            type: String,
            default: null,
        },
        id:{
            type: String,
            default: null,
        },
    },
    mounted: async function () {
        this.loadData()
        emitter.on('boost-update-data', (val) => {
            if(val) {
                this.loadData()
            }
        })
    },
    methods: {
        onPreviewClick: function() {
            alert('TODO')
        },
        reloadData: function() {
            this.loadData()
        },
        onClick: function(product) {
            if(product.code=='UPSELLING') {
                emitter.emit('upselling-payment-infos', {...product, entry: this.entry})
                emitter.emit('popup', 'upselling-payment')
                return
            }
            emitter.emit('product-payment-infos', {...product, entry: this.entry})
            emitter.emit('popup', 'product-payment')
        },
        loadData: function() {
            axios
                .post(`/api/profile/offers/${this.type}/create/${this.id}/boost`)
                .then(async (response) => {
                    this.loading = false
                    this.buttons = response.data.buttons
                    this.entry = response.data.entry
                }).catch((error) => {
                    this.loading = false
                    console.log(error)
                    Swal.fire('Fehler', this.$t('generic.error_loading'), 'error')
                })

        }
    },
    data() {
        return {
            loading: false,
            buttons: [],
            entry: null
        }
    },
}

</script>
<style lang="css" scoped>
.cursor-pointer {
    cursor:pointer;
}
.badge-hover {
    white-space: normal;
    background-color: white !important;
    color: #231F20 !important;
    font-weight: normal !important;
    transition: transform 0.3s ease-in-out;
}
.badge-hover:hover {
    /*background: #32B6B3 !important;*/
    background: rgba(255,255,255,0.6) !important;
    color: black !important;
    transform: translateY(-2px);
}

.boost-section {
    background: orange;
    padding: 15px;
    border-radius: 15px;
    border-top-right-radius: 0px;
}

</style>
